// Inventory grid rows are nested by table: { supply: {...}, inventory: {...} }.
// A row is one UPC, so two selected UPCs can share one inventory record, and
// a supply unit may have no inventory at all.

/** Distinct inventory ids of the selected rows, in selection order. */
export function bulkEditInventoryIds(rows: any[]): number[] {
  const ids: number[] = [];
  for (const row of rows) {
    const id = row?.inventory?.inventory_id;
    if (typeof id === "number" && !ids.includes(id)) ids.push(id);
  }
  return ids;
}
